// Package Imports
import React from 'react';
import { FunctionComponent } from 'react';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';

type InputProps = {
  type: 'text' | 'number';
  name: string;
  value: string | number;
  classname?: string | string[];
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  id?: string;
  min?: number;
};

const Input: FunctionComponent<InputProps> = ({
  type,
  name,
  value,
  classname = '',
  placeholder = '',
  onChange,
  disabled = false,
  id,
  min
}) => {
  const inputId = id || uuidv4();

  return (
    <input
      type={type}
      name={name}
      value={value}
      className={classNames(classname)}
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
      id={inputId}
      min={min}
    />
  );
};

export default Input;
